module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.text
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a1a7769"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/EdLoading.vue
// module id = 1356
// module chunks = 44